var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm.show ? _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-1"
  }, [_vm._v("상품권 발행")])]), _c('v-card-text', [_c('v-row', [_c('v-col', [_c('v-select', {
    attrs: {
      "label": "플랫폼 *",
      "items": _vm.platforms,
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.platform,
      callback: function ($$v) {
        _vm.$set(_vm.order, "platform", $$v);
      },
      expression: "order.platform"
    }
  })], 1), _c('v-col', [_c('v-select', {
    attrs: {
      "items": _vm.giftcards.filter(function (giftcard) {
        return giftcard.platform == _vm.order.platform;
      }),
      "item-text": "subname",
      "return-object": "",
      "label": "상품권 *",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.giftcard,
      callback: function ($$v) {
        _vm.$set(_vm.order, "giftcard", $$v);
      },
      expression: "order.giftcard"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "발권수량 *",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.quantity,
      callback: function ($$v) {
        _vm.$set(_vm.order, "quantity", $$v);
      },
      expression: "order.quantity"
    }
  })], 1), _c('v-col')], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "구매자 아이디(세일러북 아이디) *",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.sender.username,
      callback: function ($$v) {
        _vm.$set(_vm.order.sender, "username", $$v);
      },
      expression: "order.sender.username"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "구매자 연락처 *",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.sender.phone,
      callback: function ($$v) {
        _vm.$set(_vm.order.sender, "phone", $$v);
      },
      expression: "order.sender.phone"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "받는사람 이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.receiver.name,
      callback: function ($$v) {
        _vm.$set(_vm.order.receiver, "name", $$v);
      },
      expression: "order.receiver.name"
    }
  })], 1), _c('v-col')], 1), _c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "받는사람 연락처(핸드폰) *",
      "persistent-placeholder": "",
      "hide-details": "",
      "placeholder": "\"-\" 를 제외한 숫자만 입력해주세요"
    },
    model: {
      value: _vm.order.receiver.phone,
      callback: function ($$v) {
        _vm.$set(_vm.order.receiver, "phone", $$v);
      },
      expression: "order.receiver.phone"
    }
  })], 1), _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "받는사람 이메일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.receiver.email,
      callback: function ($$v) {
        _vm.$set(_vm.order.receiver, "email", $$v);
      },
      expression: "order.receiver.email"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("발행")])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }